import { createContext, useContext } from 'react';

export const AnalyticsContext = createContext();
export const useAnalyticsContext = () => useContext(AnalyticsContext);
